import request from "@/utils/request";

export function logout() {
  return request({
    url: "/userapi/logout",
    method: "post",
  });
}

export function getUserInfo() {
  return request({
    url: "/data/userinfo",
    method: "post",
  });
}

export function getGroupInfo() {
  return request({
    url: "/data/groupinfo",
    method: "post",
  });
}

export function getUserReport() {
  return request({
    url: "/data/userreport",
    method: "post",
  });
}
